/**
 * The ways a collection's map is addressed in the URL.
 *
 * A module of their own, with no imports, because two unrelated places need them: the hook that owns
 * the modal, and the analytics that log a map view. Analytics cannot import from the hook — that would
 * close a cycle, since the hook reads `ionHistory` and the navigation module calls into analytics on
 * every route change.
 *
 * The query form exists because the single page tour's hash is already the stop the reader has open, so
 * a map that took the hash would collapse the row on the way in.
 */
export const TOUR_MAP_HASH = '#tour-map'
export const LIST_MAP_HASH = '#list-map'
export const TOUR_MAP_PARAM = 'tour-map'

/** Whether a location is showing a map, however that map was addressed. */
export function isMapAddressed(hash?: string, search?: string): boolean {
	if (hash === TOUR_MAP_HASH || hash === LIST_MAP_HASH) {
		return true
	}

	return new URLSearchParams(search ?? '').has(TOUR_MAP_PARAM)
}
